import Members from '@/components/members/Members'
import CreateMember from '@/components/members/CreateMember'
import Enum from '@/shared/enum'

let membersRoutes = [
  {
    meta: {
      title: 'menu.members',
      ico: 'user-circle-o',
      permission: ['Pages.Members'],
    },
    path: '/members',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'members',
        path: '',
        meta: {permission: ['Pages.Members.View']},
        props: {prospect: false},
        component: Members,
      },
      {
        name: 'members_create',
        path: 'create',
        props: {compMode: Enum.Mode.CREATE, prospect: false},
        meta: {permission: ['Pages.Members.Create']},
        component: CreateMember,
      },
      {
        name: 'members_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE, prospect: false},
        meta: {permission: ['Pages.Members.Create']},
        component: CreateMember,
      },
      {
        name: 'members_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ, prospect: false},
        meta: {permission: ['Pages.Members.View']},
        component: CreateMember,
      },
      {
        name: 'members_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY, prospect: false},
        meta: {permission: ['Pages.Members.Create']},
        component: CreateMember,
      },
    ],
  },
  {
    meta: {
      title: 'menu.prospects',
      ico: 'user-circle',
      permission: ['Pages.Members'],
    },
    path: '/prospects',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'prospects',
        path: '',
        component: Members,
        meta: {permission: ['Pages.Members.View']},
        props: {prospect: true},
      },
      {
        name: 'prospects_create',
        path: 'create',
        props: {compMode: Enum.Mode.CREATE, prospect: true},
        meta: {permission: ['Pages.Members.Create']},
        component: CreateMember,
      },
      {
        name: 'prospects_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE, prospect: true},
        meta: {permission: ['Pages.Members.Create']},
        component: CreateMember,
      },
      {
        name: 'prospects_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ, prospect: true},
        meta: {permission: ['Pages.Members.View']},
        component: CreateMember,
      },
      {
        name: 'prospect_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY, prospect: true},
        meta: {permission: ['Pages.Members.Create']},
        component: CreateMember,
      },
    ],
  },
]

export default membersRoutes



// WEBPACK FOOTER //
// ./src/router/members.js